import { axiosAjax} from '@app/src/config/axios';

export const servicePassword = {
  async getData(values, url: string) {
    try {
      const token = `Bearer ${values.token}`;
      const password = { password: values.password };
      const { data } = await axiosAjax.put(url, password, {
        headers: {
          Authorization: token
        }
      });
      return data;
    } catch (error) {
      throw error.response.data;
    }
  }
}
